import { createRoute, useNavigate, useSearch } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { RecipeListView } from "@/features/recipes/components/recipe-list-view";
import { PageContainer } from "@fleet/ui";
import { AppErrorBoundary } from "@/components/error-boundary";

interface RecipesSearch {
  q?: string;
  tag?: string;
}

function RecipesPage() {
  const search = useSearch({ from: "/_app/recipes" });
  const navigate = useNavigate();

  // Persists filters in the URL (deep-link `?q=` + `?tag=`). `replace` avoids
  // bloating history while typing; omitting empty values keeps URLs clean.
  const syncUrl = (q: string, tag: string): void => {
    void navigate({
      to: "/recipes",
      search: {
        ...(q.trim() ? { q: q.trim() } : {}),
        ...(tag.trim() ? { tag: tag.trim() } : {}),
      },
      replace: true,
    });
  };

  return (
    <PageContainer maxWidth="3xl">
      <AppErrorBoundary variant="page" region="recipes">
        <RecipeListView
          initialSearch={search().q ?? ""}
          initialTag={search().tag ?? ""}
          onSearchChange={(q) => {
            syncUrl(q, search().tag ?? "");
          }}
          onTagChange={(tag) => {
            syncUrl(search().q ?? "", tag);
          }}
        />
      </AppErrorBoundary>
    </PageContainer>
  );
}

export const recipesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/recipes",
  validateSearch: (search: Record<string, unknown>): RecipesSearch => ({
    q: typeof search.q === "string" && search.q.trim() !== "" ? search.q : undefined,
    tag: typeof search.tag === "string" && search.tag.trim() !== "" ? search.tag : undefined,
  }),
  component: RecipesPage,
});
